// extracted by mini-css-extract-plugin
export default {"loaderPage":"FetchingUserLoader_loaderPage__NrEKC","loaderTitle":"FetchingUserLoader_loaderTitle__dT9nR"};